import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-[10px] border border-[#DCE0E5] bg-white px-4 py-2 text-sm",
          "shadow-[inset_0_1px_2px_rgba(0,0,0,0.03)]",
          "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "placeholder:text-[#9CA3AF]",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#2D7FF9] focus-visible:ring-offset-0 focus-visible:border-[#2D7FF9]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "transition-all duration-200",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
